import { render, staticRenderFns } from "./IngressosRegra.vue?vue&type=template&id=d13b6322&scoped=true&"
import script from "./IngressosRegra.vue?vue&type=script&lang=js&"
export * from "./IngressosRegra.vue?vue&type=script&lang=js&"
import style0 from "./IngressosRegra.vue?vue&type=style&index=0&id=d13b6322&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13b6322",
  null
  
)

export default component.exports